import React from 'react';
import styled from 'styled-components';

import { Link } from '@/types/serviceGroup';
import { SsoLink } from '../../../shared/Presentation/SsoLink';

type Props = {
  links: Link[];
  serviceGroupId: number;
  locale: string;
};

export const AdminLinks: React.FC<Props> = ({
  links,
  serviceGroupId,
  locale,
}) => (
  <Wrapper>
    {links.map((link, i) => {
      // URLの末尾にlocaleパラメータを追加
      const url = new URL(link.url);
      url.searchParams.append('locale', locale);

      return (
        <SsoLink
          key={i}
          link={{ ...link, url: url.toString() }}
          serviceGroupId={serviceGroupId}
        />
      );
    })}
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  > * {
    margin-right: 24px;
    margin-bottom: 0;
  }
`;
